Ext.define('SA.Dom', {
    applyStyles(el, styles) {
        Ext.DomHelper.applyStyles(el, styles);
    },

    canKebabProperty() {
        return true;
    },

    create(params) {
        if (Array.isArray(params)) {
            return params.map(item => this.create(item));
        }
        else if (this.isElement(params) || !Ext.isObject(params)) {
            return params;
        }

        var {type, style, content, ...attrs} = params,
            el = this.createEl(type),
            parsedContent = Ext.Array.from(content).map(item => this.create(item));

        this.setAttrs(el, attrs);
        this.applyStyles(el, style);

        el.append(...parsedContent);

        return el;
    },

    isElement(element) {
        return Element.prototype.isPrototypeOf(element);
    },

    setAttr(el, property, value) {
        if (this.canKebabProperty(property)) {
            property = property.replace(/([A-Z])/g, match => '-' + match.toLowerCase());
        }

        this.setAttrImpl(el, property, value);
    },

    setAttrs(el, attrs) {
        Object.entries(attrs).forEach(entry => this.setAttr(el, ...entry));
    }
});